import classNames from "classnames";
import styles from "./styles.module.scss";
import CustomTab from "shared/components/common/customTabs";
import { SettingsTabs, SettingsTabsEnums } from "shared/utils/constants";
import { useState } from "react";
import Account from "shared/components/settings/account";
import ChangePassword from "shared/components/settings/changePassword";

const Settings = () => {
  const [activeTab, setActiveTab] = useState(SettingsTabsEnums.account);
  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
  };
  return (
    <div
      className={classNames(
        styles.mainContainer,
        "flex-col",
        styles.containerPadding
      )}
    >
      <h1>Profile Settings</h1>

      <CustomTab
        tabs={SettingsTabs}
        activeTab={activeTab}
        handleActiveTab={handleTabChange}
      />
      {activeTab === SettingsTabsEnums.account ? (
        <Account />
      ) : (
        <ChangePassword />
      )}
    </div>
  );
};

export default Settings;
